import React, { useEffect, useRef, useState } from 'react';
import { adConfig } from '../config/adConfig';

const AdBanner = () => {
    const adContainerRef = useRef(null);
    const [showAdBanner, setShowAdBanner] = useState(adConfig.showAdBanner);

    useEffect(() => {
        if (!showAdBanner) return;
        // Clear the container first to prevent duplicate ads on re-renders
        if (adContainerRef.current) {
            adContainerRef.current.innerHTML = '';
        }

        const script1 = document.createElement('script');
        script1.type = 'text/javascript';
        script1.innerHTML = `
            atOptions = {
                'key' : '88ffa421242ac0102466b9809137be36',
                'format' : 'iframe',
                'height' : 90,
                'width' : 728,
                'params' : {}
            };
        `;

        const script2 = document.createElement('script');
        script2.type = 'text/javascript';
        script2.src = 'https://www.highperformanceformat.com/88ffa421242ac0102466b9809137be36/invoke.js';

        if (adContainerRef.current) {
            adContainerRef.current.appendChild(script1);
            adContainerRef.current.appendChild(script2);
        }

        return () => {
            // Cleanup if needed when unmounting
            if (adContainerRef.current) {
                adContainerRef.current.innerHTML = '';
            }
        };
    }, [showAdBanner]);

    if (!showAdBanner) return null;

    return (
        <div
            ref={adContainerRef}
            className="ad-banner-container"
            style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                margin: '2rem 0',
                gridColumn: '1 / -1',
                minHeight: '90px'
            }}
        >
        </div>
    );
};

export default AdBanner;
